import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Alert from '../../Atoms/Alert'
import InlineError from '../../Atoms/InlineError'
import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'

import { formatParticipantName } from '../../../lib/formatters'

import theme from '../../../styles/theme'

import { acceptDeclineCEOTransferRequest, fetchParticipants, clearCeoTransferData } from '../../../redux/participants'

const SpinnerContainer = styled(View)`
  height: 100px;
`

class CEOTransferAlert extends PureComponent {
  componentDidUpdate (prevProps) {
    if (!prevProps.ceoTransferRequestReceived && !!this.props.ceoTransferRequestReceived) {
      this.props.fetchParticipants()
    }
  }

  handleDecision = (action) => {
    this.props.acceptDeclineCEOTransferRequest(this.props.ceoTransferRequestReceived.id, action)
  }

  renderLoading = () => {
    const visible = !!this.props.ceoTransferRequestReceived
    return (
      <Alert
        visible={visible}
      >
        <SpinnerContainer>
          <CenteredSpinner />
        </SpinnerContainer>
      </Alert>
    )
  }

  renderError = () => {
    return (
      <Alert
        visible
        onConfirm={() => this.props.clearCeoTransferData()}
      >
        <InlineError message={this.props.acceptDeclineCeoTransferRequestError.message} />
      </Alert>
    )
  }

  render () {
    const visible = !!this.props.ceoTransferRequestReceived
    if (!visible) {
      return null
    }

    if (this.props.isLoading || !this.props.participants.length) {
      return this.renderLoading()
    }

    if (this.props.acceptDeclineCeoTransferRequestError) {
      return this.renderError()
    }

    return (
      <Alert
        visible
        onCancel={() => this.handleDecision('decline')}
        cancelInProgress={this.props.declineCeoTransferRequestInProgress}
        cancelLabel='NO'
        onConfirm={() => this.handleDecision('accept')}
        confirmInProgress={this.props.acceptCeoTransferRequestInProgress}
        confirmLabel='YES'
      >
        <Text bold>{formatParticipantName(this.props.participants.find(p => p.id === this.props.ceoTransferRequestReceived.from))} wants to promote you to CEO</Text>
        <Text overrides={{ marginTop: theme.gutterUnit }}>Do you accept?</Text>
      </Alert>
    )
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.participants.isLoading,
  isLoaded: state.participants.isLoaded,
  participants: state.participants.participants,
  ceoTransferRequestReceived: state.participants.ceoTransferRequestReceived,
  acceptCeoTransferRequestInProgress: state.participants.acceptCeoTransferRequestInProgress,
  declineCeoTransferRequestInProgress: state.participants.declineCeoTransferRequestInProgress,
  acceptDeclineCeoTransferRequestComplete: state.participants.acceptDeclineCeoTransferRequestComplete,
  acceptDeclineCeoTransferRequestError: state.participants.acceptDeclineCeoTransferRequestError
})

export default connect(mapStateToProps, { acceptDeclineCEOTransferRequest, fetchParticipants, clearCeoTransferData })(CEOTransferAlert)
